import { SubwayVariantIcon } from './SubwayVariantIcon';

/**
 * author: Google
 * id EBD55581-BE34-4D0D-A151-974FD5FD7D92
 * name subway-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subway-variant.svg
 * tags
 * - Transportation + Other 
 */
export const MetroVariantIcon = SubwayVariantIcon;
export default MetroVariantIcon